// Fecha de nacimiento como texto DD/MM/AAAA con teclado numerico.
// El <input type="date"> no abre el teclado en Android (abre un selector de
// calendario) y obliga a recorrer los anios para llegar a uno de hace 30.

export function maskDobInput(raw) {
  const d = String(raw || "").replace(/\D/g, "").slice(0, 8);
  if (d.length <= 2) return d;
  if (d.length <= 4) return `${d.slice(0, 2)}/${d.slice(2)}`;
  return `${d.slice(0, 2)}/${d.slice(2, 4)}/${d.slice(4)}`;
}

// "AAAA-MM-DD" -> "DD/MM/AAAA" para precargar el campo; "" si no hay fecha.
export function isoToDobText(iso) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || "");
  return m ? `${m[3]}/${m[2]}/${m[1]}` : "";
}

// "DD/MM/AAAA" -> "AAAA-MM-DD", o "" si esta incompleta, no existe o es futura.
export function dobTextToIso(text, today = new Date()) {
  const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(text || "");
  if (!m) return "";
  const day = Number(m[1]);
  const month = Number(m[2]);
  const year = Number(m[3]);
  if (year < 1900) return "";
  const date = new Date(year, month - 1, day);
  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) return "";
  const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  if (date > todayStart) return "";
  return `${m[3]}-${m[2]}-${m[1]}`;
}
